import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReplaceTaxKeyDataPipe } from 'src/app/pipes/replace-tax-key-data.pipe';
import { AppStateService } from 'src/app/services/init/app-state.service';

@Component({
  selector: 'app-customize',
  templateUrl: './customize.component.html',
  styleUrls: ['./customize.component.scss'],
  imports : [
    IonButton,
    TranslateModule,
    ReplaceTaxKeyDataPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class CustomizeComponent implements OnInit {
  
  public brandName: any
  public memberEmail: string
  @Input("createdMembership") public createdMembership: any
  @Input("gsttext") public gsttext: boolean
  @Input("transactionCode") public transactionCode: string
  

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private appState: AppStateService
  ) { }

  ngOnInit() {
     this.brandName = {
          brandName: this.translate.instant('configJson.brandsName')
      }
    const appData = this.appState.getAppData();
    if (appData?.emailID) { 
      this.memberEmail = appData?.emailID?.emailID;
    }
  }

  public proceedToSpouse() {
    this.modalCtrl.dismiss()
  }
}
